import { Box, makeStyles, Theme, createStyles } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { useAsyncAction } from "legacy-components/form/action/AsyncAction";
import DataRemover from "modus/components/misc/DataRemover";
import React, { useContext, useEffect } from "react";
import ApiService from "../services/ApiService";
import { FormattedMessage } from "react-intl";
import { SnackNotificationContext } from "legacy-components/notifications/GenericSnackNotification";


interface IDeploymentRemoverProp{
  deploymentId: string
  isDisabled?: boolean
  refreshDeployments: () => void;
}

const useStyles = makeStyles((theme: Theme) => createStyles({
  deleteButton: {
    color: "#FFFFFF",
    border: "none",
    backgroundColor: (props: { isDisabled?: boolean }) => 
      props.isDisabled ? "#00000042" : "#DA212C",
    '&:hover': {
      backgroundColor: (props: { isDisabled?: boolean }) => 
        props.isDisabled ? "#00000042" : "#C41017",
    }
  },
  alertMargin: {
    marginTop: "30px"
  }
}));

export const DeploymentRemover: React.FC<IDeploymentRemoverProp> = React.memo(({deploymentId, isDisabled, refreshDeployments})=>{
        const notification = useContext(SnackNotificationContext);
        const classes = useStyles({ isDisabled });

    const [deleteState, { subscribe: deleteDeployment }] = useAsyncAction(() =>
    ApiService.deleteDeployment(deploymentId)
  );

   useEffect(() => {

    if(!deleteState?.loaded || !deleteState.error || !notification) {
      return;
    }

      if (deleteState.error) {
        notification.show({
          id: "deletestate-error",
          message: deleteState.value as any,
          timeout: 4000,
        });
      }
      if (deleteState.loaded) {
        notification.show({
          id: "deletestate-success",
          message: <FormattedMessage defaultMessage="Deleted successfully." />,
          timeout: 4000,
        });
      }
    }, [deleteState.loaded, deleteState.error, deleteState.value, notification]);

    return (
            <DataRemover
              className={classes.deleteButton}
              enterButtonText={"Delete deployment"}
              onConfirm={deleteDeployment}
              asyncActionState={deleteState}
              tooltipText={"This will delete the deployment permanently."}
              title="Delete deployment"
              successMessage="Deleted Successfully"
              onSuccess={()=>{
                refreshDeployments();
              }}
              icon={<span />}
              disabled={isDisabled}
              message={
                <>
                  <Alert severity="error">
                    Deleting a deployment will break any current integrations
                    using this api.
                  </Alert>
                  <Box className={classes.alertMargin}>
                    This action cannot be undone. This will permanently remove
                    the deployment and cannot be accessed elsewhere.
                  </Box>
                </>
              }
            />
    );


})


